/**
 * Main App component with routing
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { PrivateRoute } from './components/PrivateRoute';
import { Loading } from './components/Loading';

// Pages
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Images } from './pages/Images';
import { ImageDetail } from './pages/ImageDetail';
import { Verifications } from './pages/Verifications';
import { Settings } from './pages/Settings';

// Styles
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/images"
          element={
            <PrivateRoute>
              <Images />
            </PrivateRoute>
          }
        />
        <Route
          path="/images/:id"
          element={
            <PrivateRoute>
              <ImageDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/verifications"
          element={
            <PrivateRoute>
              <Verifications />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        
        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
